import { render } from "./ForecastChart.vue?vue&type=template&id=cf594724"
import script from "./ForecastChart.vue?vue&type=script&lang=js"
export * from "./ForecastChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__